<script>
import { Bar } from "vue-chartjs";

export default {
    name: "IpTrafficBarChart",
    extends: Bar,
    props: {
        // 後端回來的資料：[{ timestamp, count, originHitCount },...]
        chartData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            chartOptions: {
                responsive: true, // 圖表自動依容器大小調整
                maintainAspectRatio: false, // 交給外層 div 控制高度
                scales: {
                    xAxes: [
                        {
                            scaleLabel: {
                                display: true, // 是否顯示標籤
                                labelString: "日期",
                            },
                            ticks: {
                                autoSkip: true, // 自動跳過部分標籤避免重疊
                                maxTicksLimit: 30,
                            },
                        },
                    ],
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true, // 是否從 0 開始
                            },
                            scaleLabel: {
                                display: true,
                                labelString: "請求次數",
                            },
                        },
                    ],
                },
                tooltips: {
                    callbacks: {
                        label(tooltipItem, data) {
                            const dsIndex = tooltipItem.datasetIndex;
                            const index = tooltipItem.index;

                            const dataset = data.datasets[dsIndex];
                            if (!dataset) return "";

                            const value = Number(dataset.data[index] || 0);

                            // 計算這個 xIndex 的所有 dataset 總和
                            const total = data.datasets.reduce((sum, ds) => {
                                if (!Array.isArray(ds.data)) return sum;
                                return sum + Number(ds.data[index] || 0);
                            }, 0);

                            if (!total) {
                                return `${dataset.label}: ${value}`;
                            }

                            const percent = ((value / total) * 100).toFixed(1);
                            return `${dataset.label}: ${value} (${percent}%)`;
                        },
                    },
                },
                legend: {
                    display: true,
                    position: "top",
                },
            },
        };
    },
    watch: {
        chartData: {
            immediate: false,
            deep: true,
            handler() {
                this.renderBarChart();
            },
        },
    },
    mounted() {
        this.renderBarChart();
    },
    methods: {
        formatTimestampToLocal(timestamp) {
            const date = new Date(timestamp); // 自動轉換成使用者時區

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");
            const hh = String(date.getHours()).padStart(2, "0");
            const mi = String(date.getMinutes()).padStart(2, "0");
            const ss = String(date.getSeconds()).padStart(2, "0");

            return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
        },
        renderBarChart() {
            if (!this.chartData || this.chartData.length === 0) return;

            const labels = this.chartData.map((item) => this.formatTimestampToLocal(item.timestamp));
            const originHitCounts = this.chartData.map((d) => d.originHitCount);
            const originMissCounts = this.chartData.map((d) => d.originMissCount);

            const datasets = [
                {
                    label: this.$t("behaviorAnalyze.missOrigin"),
                    data: originMissCounts,
                    backgroundColor: "#00b883", // 綠色
                    stack: "trafficStack",
                },
                {
                    label: this.$t("behaviorAnalyze.hitOrigin"),
                    data: originHitCounts,
                    backgroundColor: "#ff9800", // 橘色
                    stack: "trafficStack",
                },
            ];

            this.renderChart(
                { labels, datasets },
                {
                    ...this.chartOptions,
                    scales: {
                        xAxes: [
                            {
                                stacked: true,
                                scaleLabel: {
                                    display: true,
                                    labelString: this.$t("behaviorAnalyze.date"),
                                },
                            },
                        ],
                        yAxes: [
                            {
                                stacked: true,
                                ticks: {
                                    beginAtZero: true,
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: this.$t("behaviorAnalyze.requestCount"),
                                },
                            },
                        ],
                    },
                }
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Chart/IpTrafficBarChart.vue